import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppInput from '@nxsys/components/AppInput';
import AppTextEditor from '@nxsys/components/AppTextEditor';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import { ContentState, EditorState } from 'draft-js';
import React, { Ref, useImperativeHandle, useMemo } from 'react';
import htmlToDraft from 'html-to-draftjs';

export type NoteValues = {
  title: string;
  content: string;
};

export type NoteFormRef = {
  submit: () => void;
};

type NoteFormProps = {
  formRef?: Ref<NoteFormRef>;
  onSubmit: (params: NoteValues) => Promise<void>;
  defaultValues?: Partial<NoteValues>;
};

const NoteForm: React.FC<NoteFormProps> = ({
  formRef,
  onSubmit,
  defaultValues = {},
}) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm();

  useImperativeHandle(formRef, () => ({
    submit() {
      form.submit();
    },
  }));

  const onFinish: FormProps['onFinish'] = async (values) => {
    onSubmit(values);
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const editorStateInit = useMemo(() => {
    const content = defaultValues?.content || '';
    const blocksFromHtml = htmlToDraft(content);

    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap,
    );
    const editorState = EditorState.createWithContent(contentState);

    return editorState;
  }, [defaultValues?.content]);

  return (
    <AppFormContainer
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      initialValues={{
        ...defaultValues,
      }}
    >
      <Form.Item
        label={messages['common.title']}
        name="title"
        rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
      >
        <AppInput placeholder={messages['form.enter']} />
      </Form.Item>
      <Form.Item label={messages['common.description']} name="content">
        <AppTextEditor
          isSimple
          placeholder={messages['form.enter']}
          editorStateInit={editorStateInit}
          handleChange={(editorState) =>
            form.setFieldsValue({ content: editorState })
          }
        />
      </Form.Item>
    </AppFormContainer>
  );
};

export default NoteForm;
